import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Modal,
  Button,
  Image,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faTrashAlt,
  faExclamationTriangle,
  faTimes,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/pro-light-svg-icons";
import { useHistory } from "react-router-dom";
import { FormControlSearch, SliderPanel } from "../../../../components";
import {
  ssnMasking,
  usDateFormat,
  DateFormat,
  MANAGE_PAYROLL_ROUTES,
  EMPLOYEE_RECORDS_TO_FETCH,
  YYYYMMDDdateFormat,
} from "../../../../utils";
import { get, toLower, camelCase } from "lodash";
import { getErrorsInECR, deleteTempEmployeeById } from "../../../../services";
import InfiniteScroll from "react-infinite-scroller";
import { useDeepEffect } from "../../../../abstracts";
import AddToolTip from "../../../../components/AddToolTip";
import authService from "../../../../components/api-authorization/AuthorizeService";
import permissions from "../../../../mocks/menuPermissions.json";
import PayrollCensusDetails from "../../ErrorFoundInRecordsContainer/PayrollCensusDetails";
const ErrorReports = (props) => {
  const {
    fileId,
    countTrigger,
    setcountTrigger,
    errors,
    setIsSubmit,
    homeSetIsLoading,
    toggleUseEffect,
    menu,
    subMenu,
    revalidateIds,
    revalidateFile,
    countries,
    states,
    frequencyList,
  } = props;
  const history = useHistory();
  const [errorRecords, setErrors] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [recordToDelete, setRecordToDelete] = useState({});
  const [selectedTabIndex, setTabIndex] = useState("error");
  const [filteredValues, setFilteredValues] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [employeeId, setEmplyeeId] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isErrorCollapse, setIsErrorCollapse] = useState([]);
  const [request, setRequest] = useState({
    fileId: fileId,
    from: 0,
    offset: EMPLOYEE_RECORDS_TO_FETCH,
    searchInput: "",
  });
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  useDeepEffect(() => {
    homeSetIsLoading(true);
    getErrorsInECR(request).then((response) => {
      if (response?.length < EMPLOYEE_RECORDS_TO_FETCH)
        setStopInfiniteScroll(true);
      if (append && searchTerm == "")
        setFilteredValues([...filteredValues, ...response]);
      else {
        setErrors(response);
        setFilteredValues(response);
        setStopInfiniteScroll(false);
      }
      homeSetIsLoading(false);
    });
  }, [request, toggle, isSliderOpen]);
  useDeepEffect(() => {
    if (searchTerm == "") setRequest({ ...request, from: 0, searchInput: "" });
    else {
      setRequest({
        ...request,
        from:
          filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
            ? 0
            : filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH,
        searchInput: searchTerm,
      });
    }
  }, [searchTerm]);

  const removeOne = (item) => {
    setIsModalOpen(true);
    setRecordToDelete(item);
  };

  const handleSearchChange = (e) => {
    const val = e.target.value;
    val.includes("/")
      ? setSearchTerm(YYYYMMDDdateFormat(val))
      : setSearchTerm(val);
    if (!stopInfiniteScroll) {
      setAppend(false);
      //setFilteredValues([]);
      //setRequest({ ...request, from: 0, searchInput: "" });
    }
    // setFilteredValues(
    //   errorRecords
    //   // .filter((item) => {
    //   //   return (
    //   //     toLower(item.ssn).replace(/-/g, "").indexOf(toLower(val)) !== -1 ||
    //   //     toLower(item.employeeName).indexOf(toLower(val)) !== -1
    //   //   );
    //   // })
    // );
  };

  const onDeleteConfirmClick = () => {
    const id = get(recordToDelete, "id");
    // setFilteredValues(
    //   filteredValues.filter((item) => {
    //     return toLower(item.ssn) !== selectedSsn;
    //   })
    // );
    deleteTempEmployeeById(id).then((response) => {
      setFilteredValues([]);
      setRequest((request) => {
        return { ...request, from: 0 };
      });
      setSliderOpen(false);
      toggleUseEffect();
      setToggle(!toggle);
      var idLength = errorRecords.length;
      if (idLength == 1) {
        setIsModalOpen(false);
        history.push({
          pathname: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
        });
      } else {
        setIsModalOpen(false);
        setRecordToDelete({});
      }
    });
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setRecordToDelete({});
  };

  return (
    <div>
      <div className="search-bar-warning-page d-flex-row mt-3 justify-content-space-between">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            setRequest({
              ...request,
              from:
                filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
                  ? 0
                  : filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH,
              searchInput: searchTerm,
            });
          }}
        >
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text className="plan-search-button">
                <Image src="/assets/icons/svg/search.svg" width="14px" />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControlSearch
              type="search"
              placeholder="Search employee name, SSN, pay date"
              onChange={handleSearchChange}
            />
          </InputGroup>
        </Form>
        {/* <Button
          className="payroll-search-button"
          variant="secondary"
          style={{ marginTop: "auto", marginLeft: "10px" }}
          onClick={() =>
            setRequest({
              ...request,
              from:
                filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
                  ? 0
                  : filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH,
              searchInput: searchTerm,
            })
          }
        >
          Search
        </Button> */}
        {/* <div
          className="link-text-mapper ft-14 cursor-pointer"
          style={{
            marginRight: "5px",
            marginTop: "8px",
          }}
          onClick={() => {
            revalidateIds(revalidateFile);
          }}
        >
          <i class="fa fa-retweet mr-2" aria-hidden="true"></i>Revalidate
        </div> */}
      </div>
      <div
        className="error-types-box-var1 font-weight-500 mt-2 d-flex"
        style={{ width: "100%" }}
      >
        <Col md="2" className="grey-text">
          Social Security Number
        </Col>
        <Col md="2" className="grey-text">
          Employee name
        </Col>
        <Col md="1" className="grey-text">
          Pay date
        </Col>
        {/* <Col md="5">Errors</Col>
        <Col md="1">Action</Col> */}
        <Col md="6" className="grey-text">
          Errors
        </Col>
      </div>
      <div
        className="cursor-pointer validation-error-report w-100"
        //style={{ overflow: "scroll", height: "60vh" }}
      >
        <InfiniteScroll
          pageStart={0}
          loadMore={() => {
            setAppend(true);
            setRequest({
              ...request,
              from: filteredValues?.length,
              searchInput: searchTerm,
            });
          }}
          hasMore={!stopInfiniteScroll}
          initialLoad={false}
          threshold={100}
          useWindow={false}
          loader={
            isLoading ? (
              <div className="loader" key={0}>
                Loading ...
              </div>
            ) : filteredValues.length < 1 ? (
              <div className="no-found">No Errors Found</div>
            ) : null
          }
        >
          {filteredValues.map((error, index) => {
            isErrorCollapse.push(false);
            return (
              <>
                <Row
                  onClick={() => {
                    setSliderOpen(true);
                    setEmplyeeId(error.id);
                  }}
                  className="error-types-box-var font-weight-400 mt-3"
                  key={index}
                  style={{ width: "100%" }}
                >
                  <Col
                    md="2"
                    className="align-self-center black-text"
                    style={{ width: "200px" }}
                  >
                    {ssnMasking(error.ssn)}
                  </Col>
                  <Col md="2" className="align-self-center black-text pr-2">
                    <AddToolTip name={error.employeeName} placement="bottom">
                      {error.employeeName}
                    </AddToolTip>
                  </Col>
                  <Col md="1" className="align-self-center black-text">
                    {usDateFormat(error.paydate)}
                  </Col>
                  <Col md="5" className="align-self-center grey-text">
                    {error.employeeErrors.map(
                      (code, i) =>
                        (isErrorCollapse[index] || i < 2) && (
                          <div className="black-text font-weight-500 mb-10 column-align">
                            <span className="font-weight-250 grey-text">
                              {code.messageCode}
                            </span>
                            <AddToolTip
                              className="short-desc"
                              name={code.messageDescCode}
                              placement="bottom"
                            >
                              {
                                <div
                                  style={{
                                    marginTop: "1px",
                                  }}
                                >
                                  {" "}
                                  &nbsp;- {code.messageDescCode}
                                </div>
                              }
                            </AddToolTip>
                          </div>
                        )
                    )}
                  </Col>
                  <Col md="2" className="align-self-center">
                    <div className="d-flex justify-content-end">
                      {error.employeeErrors.length > 2 && (
                        <Link
                          className="collapse-errors"
                          onClick={(e) => {
                            isErrorCollapse[index] = !isErrorCollapse[index];
                            e.stopPropagation();
                          }}
                        >
                          {isErrorCollapse[index]
                            ? `Hide Less`
                            : `+ ${error.employeeErrors.length - 2} View More`}
                          <span className="pl-2 collapse-errors-icon">
                            <FontAwesomeIcon
                              icon={
                                isErrorCollapse[index]
                                  ? faChevronUp
                                  : faChevronDown
                              }
                            />
                          </span>
                        </Link>
                      )}
                    </div>
                  </Col>
                  {/* <Col md="1" className="align-self-center">
                <div className="d-flex justify-content-between">
                  <div
                    className="link-text"
                    onClick={() => onClick(errorRecords, error.id)}
                  >
                    <a
                      className="new-linkText mt-0"
                      style={{ paddingLeft: "10px" }}
                    >
                      view
                    </a>
                  </div>
                  {permissions[roleName][menu + "SubMenu"][
                    camelCase(subMenu)
                  ].includes("D") ? (
                    <div onClick={() => removeOne(error)}>
                      <FontAwesomeIcon
                        style={{ marginTop: "15px" }}
                        icon={faTrashAlt}
                        size="sm"
                        color="#ff0000"
                        className="pointer"
                      />
                    </div>
                  ) : null}
                </div>
              </Col> */}
                </Row>
              </>
            );
          })}
        </InfiniteScroll>
      </div>
      <SliderPanel
        isOpen={isSliderOpen}
        showBackButton={false}
        showCancel={false}
        size="90"
        onClose={() => setSliderOpen(false)}
      >
        <PayrollCensusDetails
          setcountTrigger={setcountTrigger}
          countTrigger={countTrigger}
          setTabIndex={setTabIndex}
          selectedTabIndex={selectedTabIndex}
          setSliderOpen={setSliderOpen}
          payrollId={fileId}
          employeeId={employeeId}
          setIsModalOpen={setSliderOpen}
          homeSetIsSubmit={setIsSubmit}
          countries={countries}
          states={states}
          frequencyList={frequencyList}
        />
      </SliderPanel>
      <Modal show={isModalOpen} onHide={handleClose}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              <h4>Delete Employee ?</h4>
              <p>
                You are attempting to delete employee from file. Do you wish to
                Delete ?
              </p>
              <div>{ssnMasking(get(recordToDelete, "ssn", ""))}</div>
              <div>{get(recordToDelete, "employeeName", "")}</div>
              <br />
              <Button
                className="remove-btn mr-4"
                onClick={onDeleteConfirmClick}
              >
                Delete
              </Button>
              <Button className="cancel-btn" onClick={handleClose}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ErrorReports;
